/**
 * Per-estimate last Cost Breakdown / Estimation sheet.
 * Selecting an estimate used to always land on CB Summary; we restore the
 * sheet the user was on the last time they had that estimate open.
 */
const LS_MENU_BY_ESTIMATE = 'estimation_menu_by_estimate';
const DEFAULT_MENU = 'cost-breakdown-summary';
const MAX_ENTRIES = 200;

const estimateKey = (estimateId) => {
  if (estimateId == null || estimateId === '') return null;
  return String(estimateId);
};

const readMap = () => {
  try {
    const raw = localStorage.getItem(LS_MENU_BY_ESTIMATE);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
};

export function getLastMenuForEstimate(estimateId) {
  const key = estimateKey(estimateId);
  if (!key) return null;
  const value = readMap()[key];
  return typeof value === 'string' && value ? value : null;
}

export function setLastMenuForEstimate(estimateId, menuItem) {
  const key = estimateKey(estimateId);
  if (!key || !menuItem) return;
  try {
    const map = readMap();
    map[key] = menuItem;
    const keys = Object.keys(map);
    if (keys.length > MAX_ENTRIES) {
      keys.slice(0, keys.length - MAX_ENTRIES).forEach((k) => { delete map[k]; });
    }
    localStorage.setItem(LS_MENU_BY_ESTIMATE, JSON.stringify(map));
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * Which sheet to open when the user picks an estimate.
 * Remembered sheet wins. First visit while already in Estimation keeps the
 * current sheet (do not bounce to the one-pager). First visit from elsewhere
 * lands on CB Summary.
 * @returns {string|null} menu id, or null to leave the current sheet alone
 */
export function resolveMenuOnEstimateSelect({ estimateId, alreadyOnEstimation } = {}) {
  const remembered = getLastMenuForEstimate(estimateId);
  if (remembered) return remembered;
  if (alreadyOnEstimation) return null;
  return DEFAULT_MENU;
}
